import { matchPath, useLocation } from 'react-router-dom';
import { paths, routePaths } from 'routes/paths';

// i.e. "/pitches/list/abc123"
const pitchListRoutePattern = `${paths.pitches.root}${routePaths.pitches.list}`;

/**
 * Active pitch list id derived from the URL.
 * Primarily used for components outside the PitchesRouter route tree (i.e. left sidebar)
 */
export const useActiveListId = (): string | undefined => {
  const location = useLocation();
  return matchPath(pitchListRoutePattern, location.pathname)?.params.id;
};
